import { createTheme } from "@mui/material";

let kimiaTheme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#2530B8",
    },
  },
  typography: {
    fontFamily: "IRANSans",
    h2: {
      fontSize: "1.25rem",
      fontWeight: "900",
    },
    h3: {
      fontSize: "0.875rem",
      lineHeight: "22px",
    },
    h4: {
      fontSize: "1rem",
    },
    h5: {
      fontSize: "0.75rem",
    },
    h6: {
      fontSize: "0.625rem",
    },
  },
});

export default kimiaTheme;
